import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  MatButtonModule,
  MatFormFieldModule,
  MatIconModule,
  MatPaginatorModule,
  MatSortModule,
  MatTableModule,
  MatTooltipModule
} from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { FcHorizontalBarChartModule } from '@core/components/charts/fc-horizontal-bar-chart/fc-horizontal-bar-chart.module';
import { HorizontalBarChartModule } from '@core/components/charts/horizontal-bar/horizontal-bar.module';
import { PieChartModule } from '@core/components/charts/pie/pie.module';
import { ExportDialogModule } from '@core/components/export-dialog/export-dialog.module';
import { FcDateInputModule } from '@core/components/fc-input/base/fc-date-input/fc-date-input.module';
import { FcCompaniesInputModule } from '@core/components/fc-input/search-many/fc-companies-input/fc-companies-input.module';
import { FcLocationGroupsInputModule } from '@core/components/fc-input/search-many/fc-location-groups-input/fc-location-groups-input.module';
import { FcLocationsInputModule } from '@core/components/fc-input/search-many/fc-locations-input/fc-locations-input.module';
import { FcMaintenanceTypesInputModule } from '@core/components/fc-input/search-many/fc-maintenance-types-input/fc-maintenance-types-input.module';
import { FcSegmentsInputModule } from '@core/components/fc-input/search-many/fc-segments-input/fc-segments-input.module';
import { FcPaginatorModule } from '@core/components/fc-paginator/fc-paginator.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ReportsModule } from '../reports.module';
import { AlternativeQuestionChartComponent } from './dashboard-forms-detail/alternative-question-chart/alternative-question-chart.component';
import { DashboardFormsDetailComponent } from './dashboard-forms-detail/dashboard-forms-detail.component';
import { DashboardFormsListComponent } from './dashboard-forms-list/dashboard-forms-list.component';
import { DashboardFormsComponent } from './dashboard-forms.component';
import { FilterComponent } from './filter/filter.component';
import { FilterService } from './filter/filter.service';
import { FormsReportService } from './services/forms-report.service';

const routes: Routes = [
  {
    path: 'relatorios/formularios',
    component: DashboardFormsComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.REPORTS.TITLES.FORMS' },
    children: [
      {
        path: '',
        component: DashboardFormsListComponent,
        canActivate: [AuthenticatedGuard],
        data: { title: 'CORE.SERVICES.NAVIGATION.REPORTS.TITLES.FORMS' },
      },
      {
        path: 'detalhes',
        component: DashboardFormsDetailComponent,
        canActivate: [AuthenticatedGuard],
        data: { title: 'CORE.SERVICES.NAVIGATION.REPORTS.TITLES.FORMS' },
      },
    ]
  },
];

@NgModule({
  declarations: [
    FilterComponent,
    DashboardFormsComponent,
    DashboardFormsListComponent,
    DashboardFormsDetailComponent,
    AlternativeQuestionChartComponent
  ],
  imports: [
    PipesModule,
    CommonModule,
    TranslateModule,
    FuseSharedModule,
    RouterModule.forChild(routes),
    ReportsModule,

    PieChartModule,
    NgxSkeletonLoaderModule,
    HorizontalBarChartModule,

    MatIconModule,
    MatSortModule,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatPaginatorModule,

    FcDateInputModule,
    FcPaginatorModule,
    FcSegmentsInputModule,
    FcLocationsInputModule,
    FcCompaniesInputModule,
    FcLocationGroupsInputModule,
    FcHorizontalBarChartModule,
    FcMaintenanceTypesInputModule,
    ExportDialogModule
  ],
  providers: [
    FilterService,
    FormsReportService
  ]
})
export class DashboardFormsModule {}
